import http from "../../../../../core/utils/apis/skillApi";

const TrainingFeedbacksOverviewService = {
  getTopTrainerFeedbackAspects: () =>
    http.get("/trainings-reports/top-feedback-aspects"),

  getTopTraineeFeedbackAspects: () =>
    http.get("/trainee-feedback/stats/top-aspects"),

  getGlobalTraineeFeedbackStats: () =>
    http.get("/trainee-feedback/stats/global"),
  
  getGlobalTrainerFeedbackStats: () =>
    http.get("/trainings-reports/feedbacks/percentage"),
};

export default TrainingFeedbacksOverviewService;
